import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { SettingsService } from './settings.service';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class TranslationService {
  private currentLang = new BehaviorSubject<string>('fr');

  constructor(
    private translate: TranslateService,
    private settingsService: SettingsService
  ) {
    // Définir les langues disponibles
    this.translate.addLangs(['fr', 'en']);
    
    // Définir le français comme langue par défaut
    this.translate.setDefaultLang('fr');
    
    // Initialiser avec le français
    this.translate.use('fr');

    // S'abonner aux changements de paramètres
    this.settingsService.settings$.subscribe(settings => {
      if (settings?.contentDisplay?.language) {
        const newLang = settings.contentDisplay.language;
        if (this.currentLang.value !== newLang) {
          this.setLanguage(newLang);
        }
      }
    });
  }

  getCurrentLang(): string {
    return this.currentLang.value;
  }

  setLanguage(lang: string): void {
    if (this.translate.getLangs().includes(lang)) {
      this.translate.use(lang);
      this.currentLang.next(lang);
      
      // Mettre à jour les paramètres uniquement si nécessaire
      this.settingsService.settings$.subscribe(settings => {
        if (settings?.contentDisplay?.language !== lang) {
          this.settingsService.updateSettings('contentDisplay', { language: lang });
        }
      }).unsubscribe(); // Se désabonner immédiatement après la vérification
    }
  }

  getAvailableLanguages(): string[] {
    return this.translate.getLangs();
  }
}
